// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { DirectMessageBaseClass } from './DirectMessageBase';
import { Message } from './Message';
export class DirectFundingRateMarkupPlanMessage extends DirectMessageBaseClass {
    constructor() {
        super(Message.CODE_PFIX_FUNDING_RATE_MARKUP_PLAN_MESSAGE);
        this.Id = null;
        this.Name = null;
        this.Data = []; // Example of item is lying in FundingRateMarkupPlanMessageProcessor.ts
    }
}
